import TripLocalityPropertyApi from "../../services/api/TripLocalityProperty";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";

function handleError(err) {
  console.log("error in bulk upload action:", err);
}

export const bulkUploadTripLocalityProperty = (payload) => async (dispatch) => {
  try {
    dispatch(setLoader(true));
    let response = await TripLocalityPropertyApi.bulkUploadTropLocalityProperty(
      payload
    );
    dispatch(setLoader(false));
    return response;
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
